module.exports = __webpack_public_path__ + "static/media/explorador_b.49b3371a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/explorador_b.png
// module id = 1177
// module chunks = 0